<template>
  <div v-if="signedIn === true" class="control-icon more has-items text-center">
    <svg class="olymp-chat---messages-icon">
      <use xlink:href="/svg-icons/sprites/icons.svg#olymp-chat---messages-icon" />
    </svg>
    <div class="label-avatar bg-primary" style="right: 9px;">{{ notifications_count }}</div>
    <div class="label-description">Notifications</div>
    <div class="more-dropdown more-with-triangle triangle-top-center" ref="notifications">
      <div class="ui-block-title ui-block-title-small">
        <h6 class="title">Notifications</h6>
        <a href="#" v-if="notifications_count > 0">Mark all as read</a>
        <a href="#" v-if="notifications_count > 0">Settings</a>
      </div>

      <div v-if="notifications_count < 1" class="mCustomScrollbar" data-mcs-theme="dark">
        <div style="padding: 30px;text-align:center" class="comment-photo">
            <img width="220" src="/img/404.png">
          <span style="font-size:20px">“You have no notification here”</span>
        </div>
      </div>

      <div v-if="notifications_count > 0" class="mCustomScrollbar" data-mcs-theme="dark">
        <ul class="notification-list">
          <li v-for="(notification,index) in notifications" :key="index">
<!--            <div class="author-thumb">-->
<!--              <img :src="notification.dp === null ? '' : notification.dp " width="30" height="30" alt="author" />-->
<!--            </div>-->
            <div class="notification-event">
              <div>
                <router-link to="/" class="h6 notification-friend">{{ notification.message }}</router-link>
              </div>
              <span class="notification-date">
                <time class="entry-date updated" datetime="2004-07-24T18:18"> {{ $timeAgo.format(new Date(new Date(notification.created_at * 1000))) }} </time>
              </span>
            </div>
            <span class="notification-icon" v-if="notification.status === true ">
              <svg class="olymp-heart-icon">
                <use xlink:href="svg-icons/sprites/icons.svg#olymp-check-icon"></use>
              </svg>
            </span>

<!--            <div class="more">-->
<!--              <svg class="olymp-little-delete">-->
<!--                <use xlink:href="/svg-icons/sprites/icons.svg#olymp-little-delete" />-->
<!--              </svg>-->
<!--            </div>-->
          </li>


        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import ls from "../localstorage";
export default {
  data() {
    return {
      signedIn: false,
      notifications_count: 0,
      notifications: {},
      first_page_url: "",
      last_page_url: "",
      next_page_url: "",
    };
  },
  methods: {
    checkUserData(userData) {
      if (userData !== "" || userData !== "undefined") {
        this.userData = JSON.parse(userData);
        this.signedIn = true;
      }
    },
    showLoading() {
      let loader = this.$loader(this, this.$refs.notifications, {
        loaderType: "spinner"
      });
      return loader;
    },
    getNotifications() {
      if (ls.checkStorage("fansData")) {
        let userData = ls.getStorage("fansData");
        userData = userData[0].id;
        // let loader = this.showLoading();
        this.axios.get(`/notifications/all/7`)
                .then(response => {
                  // loader.hide();
                  // console.log(response.data.data.status)
                  if (response.data.data.status === true) {
                    this.notifications_count = response.data.data.count;
                    this.first_page_url = response.data.data.notifications.first_page_url;
                    this.last_page_url = response.data.data.notifications.last_page_url;
                    this.next_page_url = response.data.data.notifications.next_page_url;
                    this.notifications = response.data.data.notifications.data;
                  }
                })
                .catch(error => {
                  // loader.hide();
                  // console.log(error)
                    return error;
                })
      }
    },
    getUserAvatar(username) {
      this.axios
              .get("/other/detailsin/" + username + "/1")
              .then(response => {
                var responseData = response.data.data;
                // console.log(responseData);
                if (responseData.type === 1) {
                  return responseData.avatar;
                }else {
                  return responseData.logo;
                }
              })
              .catch(error => {
                //   console.log(error);
                return error;
              });
    },
  },
  mounted() {
    var userData = localStorage.fansData;
    if (userData) {
      this.checkUserData(userData);
    }
    this.getNotifications();

    setInterval(()=>{
        this.getNotifications();
    },50000);

      CRUMINA.perfectScrollbarInit = function () {
          var $chatContainer = $('.popup-chat-responsive .mCustomScrollbar');
          var $containers = $('.mCustomScrollbar');

          $containers.perfectScrollbar({wheelPropagation:false});

          if(!$chatContainer.length){
              return;
          }

          $chatContainer.scrollTop( $chatContainer.prop( "scrollHeight" ) );
          $chatContainer.perfectScrollbar('update');
      };

  }
};
</script>

<style>
</style>
